const {Status, VOLUNTARY, INVOLUNTARY} = require('./status');

class StatusInfo {
    constructor({bookingId, keys = {}} = {}) {
        this.bookingId = bookingId;
        this.keys = keys;

        this.voluntary = new Status({
            type: VOLUNTARY,
            bookingId,
            keys: this.keys,
        });

        this.involuntary = new Status({
            type: INVOLUNTARY,
            bookingId,
            keys: this.keys,
        });

        this.promise = Promise.all([
            this.voluntary.promise,
            this.involuntary.promise,
        ]);
    }

    then(handler = () => {}) {
        return this.promise.then(() => {
            if (this.shouldShowNotification()) {
                handler(this.voluntary.info);
            }
        });
    }

    shouldShowNotification() {
        return this.voluntary.isValid() && !this.involuntary.isValid();
    }
}

module.exports = StatusInfo;
